<template lang="html">
  <div class="tab">
    <div class="logo-box">
      <img src="~common/ter/images/logo.png" alt="因他科技" title="因他科技">
      <!-- <i class="icon iconfont icon-gengduo2" @click="openNav"></i> -->
    </div>
    <div class="nav-wrap" ref="navWrap">
      <div class="nav-box">
        <router-link v-for="(item, index) in navData" :key="index" class="tab-item" tag="div" :to="item.url" @click="changeNav(item.children.length)">
          <span class="tab-link">{{item.tabName}}</span>
          <ul v-if="item.children.length" class="sub-tab">
            <li v-for="(inItem, inIndex) in item.children" :key="index + inIndex">
              <router-link class="sub-t-item" tag="div" to="">
                <span class="sub-t-link" @click="blankTargt(inItem.url)">{{inItem.tabName}}</span>
              </router-link>
            </li>
          </ul>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import navData from 'json/ter/header.json'
// import {mapGetters, mapMutations} from 'vuex'
// console.log(mapGetters)
export default {
  data () {
    return {
      // isOpen: false,
      navData: []
    }
  },
  // computed: {
  //   ...mapGetters([
  //     'navShow'
  //   ])
  // },
  mounted () {
    this.navData = navData
  },
  methods: {
    // ...mapMutations({
    //   setNavShow: 'SET_NAVSHOW'
    // }),
    // changeNav (flag) {
    //   console.log(flag)
    //   if (!flag) {
    //     this.openNav()
    //   }
    // },
    blankTargt (url) {
      window.open(url)
    }
    // openNav () {
    //   this.setNavShow(!this.navShow)
    // }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/ter/stylus/base'
.tab
  width: 100%
  height: 50px
  position: fixed
  z-index: 999
  background-color: #fff
  .logo-box
    display: flex
    justify-content: space-between
    align-items: center
    padding: 11px
    img
      /* height: 28px */
      height: 24px
      padding: 2px 0
    .icon
      font-size: 15px
      font-weight: bolder
      color: #999
  .nav-wrap
    animation: subtab 0.3s ease
  .nav-box
    width: 100%
    height: 35px
    display: flex
    justify-content: space-around
    align-items: center
    background-color: #F5F5F5
    font-size: 12px
    &>.router-link-exact-active
      color: #007CE5
      &:after
        content: ''
        width: 100%
        height: 3px
        animation: active-line 0.3s ease
        position: absolute
        bottom: 0
        left: 0
        background-color: #007CE5
      &>.sub-tab
        display: block
    &>.tab-item
      position: relative
      padding: 11px 0
  .sub-tab
    width: 60px
    display: none
    position: absolute
    top: 34px
    left: -6px
    animation: subtab 0.3s ease
    background-color: #F5F5F5
    color: #333
    li
      border-bottom: 1px solid #eee
    .sub-t-item
      text-align: center
      white-space: nowrap
      padding: 8px 0
      font-size: 12px
      &>.router-link-active
        background-color: #DDDDDD
@keyframes active-line
  0% {
    transform: scale3d(0.1, 1, 1)
  }
  100% {
    transform: scale3d(1, 1, 1)
  }
@keyframes subtab {
  0% {
    transform: translateY(-20px)
    opacity: 0
  }
  100% {
    transform: translateY(0)
    opacity: 1
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ter/header/header.vue